import ItemTable from '../../components/TabSpr.vue'
import LimitTable from './LimitTab.vue'
import InputGroupForm from "@/components/InputGroupForm";
import http from '@/http-common'

export default {
    components: {ItemTable, LimitTable, InputGroupForm},
    data() {
        return {
            captionTable: 'Лимиты ЕКП',
            items: [],
            editItem: {},
            urls: {
                save: '/limit/save',
                delete: '/limit',
            },
            captionSpr: {
                name: 'Лимит ЕКП',
                nameR: 'лимита ЕКП'
            },
            columns: [
                {key: 'orgName', label: 'Организация'},
                {key: 'ekpTypeName', label: 'Вид ЕКП'},
                {key: 'limitYear', label: 'Год'},
                {key: 'limitSumma', label: 'Лимит суммы (руб.)'},
                {key: 'comment', label: 'Комментарий'},
                {key: 'edit_field', label: ''}
            ],
            selectedItem: {id: 0, limitYear: 0, limitSumma: 0, comment: ''},
            modalEditOpened: false,
            validValue: {
                limitYear: true,
                limitSumma: true,
                form: true,
            },
            orgList: [],
            ekpTypeList: [],
            yearList: [],
            selectedYear: new Date().getFullYear(),
            isBusy: false,
            columnsDetail: [
                {key: 'fedName', label: 'Федерация'},
                {key: 'limitSumma', label: 'Лимит суммы (руб.)'},
                {key: 'comment', label: 'Комментарий'},
                {key: 'edit_field', label: ''}
            ],
            fedList: [],
            countRecord: 0
        }
    },
    created() {
        this.loadItems();
        var y = this.selectedYear
        for (var i = y - 2; i < y + 2; i++) {
            var n = {}
            n.text = i.toString()
            n.value = i
            this.yearList.push(n);
        }
    },
    methods: {
        checkForm() {
            for (var key in this.validValue) {
                this.validValue[key] = true;
            }
            if (!this.selectedItem.limitYear || this.selectedItem.limitYear <= 0) {
                this.validValue.limitYear = false;
                this.validValue.form = false;
            }
            if (!this.selectedItem.limitSumma || this.selectedItem.limitSumma <= 0) {
                this.validValue.limitSumma = false;
                this.validValue.form = false;
            }
        },
        loadItems() {
            var vm = this;
            this.isBusy = true;
            http.get('/limit/list/' + this.selectedYear)
                .then((response) => {
                    vm.items = response.data;
                })
                .catch((error) => console.log(error.response.data))
                .finally(() => this.isBusy = false);
        },
        showEditDialog() {
            this.loadOrgs();
            this.loadEkpTypes();
            // this.loadDetails()
            // this.loadFederations()
            this.modalEditOpened = !this.modalEditOpened;
        },
        loadOrgs() {
            var vm = this;
            http.get('/org/list')
                .then((response) => {
                    vm.orgList = response.data;
                    vm.orgList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.shortName;
                    })
                    if (!vm.selectedItem.id || vm.selectedItem.id == null)
                        vm.selectedItem.orgId = vm.orgList[0].id;
                })
                .catch((error) => console.log(error.message))
        },
        loadEkpTypes() {
            var vm = this;
            http.get('/workkind/EKP_TYPE/list')
                .then((response) => {
                    vm.ekpTypeList = response.data;
                    vm.ekpTypeList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.name;
                    })
                    if (!vm.selectedItem.id || vm.selectedItem.id == null)
                        vm.selectedItem.ekpTypeId = vm.ekpTypeList[0].id;
                })
                .catch((error) => console.log(error.message));
        },
        saveLimit() {
            this.checkForm();
            if (this.validValue.form) {
                this.selectedItem.detailFederations = this.$refs.fedDetails.details;
                this.selectedItem.detailSportKinds = this.$refs.kindDetails.details;
                this.modalEditOpened = false;
                this.$refs.ItemTab.save(this.selectedItem);
            }
        }
    }
}
